<!-- footer -->
<footer class="sigma_footer footer-2">
  <!-- Footer Bottom -->
  <div class="sigma_footer-bottom">
    <div class="container-fluid">
      <div class="sigma_footer-copyright">
        <p> Copyrights © {{ CurrentYear}}. All Rights Reserved </p>
      </div>
      <div class="sigma_footer-logo">
        <a href="index.html" target="_blank"><img src="../../../../assets/images/logo.png" alt="logo"></a>
      </div>
      <ul class="sigma_sm square">
        <a href="https://www.cybrain.co.in" target="_blank"><img src="../../../../assets/images/cybrain-logo.png"
            alt="cybrain software solution logo"></a>
      </ul>
    </div>
  </div>
</footer>